import { useState, useEffect, useContext } from "react";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { GlobalContext } from "../../../../common/Context";
import { useTranslation } from "react-i18next";
import { black, boxShadow, purple } from "../../../../../theme/colours";
import { LeaderboardNavIcon } from "../../../../common/Icons";

const CompetitionDDL = ({
  setCurrCompetition,
  currCompetition,
  isDisabled = false,
  full,
  disableLabel,
  extraOptions = [],
}) => {
  const { competitionList, mobileView, tabletView, currentUser } =
    useContext(GlobalContext);
  const { t } = useTranslation("SafeRoads");

  const containerStyle = {
    width: "100%",
    flex: 1,
  };
  const ddlStyle = {
    borderRadius: "5px",
    boxShadow: `0 3px 30px ${boxShadow}`,
    mb: "0.75rem",
    width: full ? "100%" : mobileView ? "auto" : tabletView ? "15rem" : "100%",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& label, & label.Mui-focused": {
      color: purple[1],
    },
    "& svg": {
      fill: purple[1],
      width: "1.25rem",
      ml: "0.625rem",
    },
  };
  const inputStyle = {
    height: "1rem",
    color: purple[1],
    fontSize: "1rem",
    fontWeight: 600,
    paddingLeft: "1rem",
  };
  const optionStyle = (option) => {
    let style = {};

    if (option.id === 0) {
      style = {
        ...style,
        color: black,
        fontWeight: 700,
      };
    }
    return style;
  };
  const labelStyle = {
    lineHeight: "2",
    fontWeight: 700,
  };

  const [displayValue, setDisplayValue] = useState();
  const [optionData, setOptionData] = useState();

  useEffect(() => {
    currCompetition && setDisplayValue(currCompetition.title);
  }, [currCompetition]);

  useEffect(() => {
    if (currentUser && competitionList) {
      setOptionData([...extraOptions, ...competitionList]);
    }
  }, [currentUser, competitionList]);

  const handleChange = (_event, value) => {
    const selected = { ...value };
    const selGroup = optionData?.find((group) => group.id === selected.id);
    if (!currCompetition || selGroup.id !== currCompetition.id) {
      setCurrCompetition(selGroup);
    }
  };

  return (
    <Box sx={containerStyle}>
      {!disableLabel && (mobileView || tabletView) && (
        <Typography variant="h4" sx={labelStyle}>
          {t("selectTeam")}
        </Typography>
      )}
      <Autocomplete
        sx={ddlStyle}
        disableClearable={true}
        options={optionData || []}
        value={displayValue}
        defaultValue={currCompetition}
        disablePortal
        onChange={handleChange}
        autoHighlight
        disabled={isDisabled || !optionData}
        getOptionLabel={(option) => option.title}
        renderOption={(props, option) => (
          <Box
            sx={optionStyle(option)}
            component="li"
            {...props}
            key={option.id}>
            {option.title}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={"Select a competition"}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
              style: inputStyle,
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <LeaderboardNavIcon />
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
        ListboxProps={{
          style: {
            maxHeight: "11rem",
          },
        }}
      />
    </Box>
  );
};

export default CompetitionDDL;
